export default __webpack_public_path__ + "land-use-plan-800-176de3a17e32ab3b666eba316188a3e1.webp";